import { render, staticRenderFns } from "./secondLogoRow.vue?vue&type=template&id=a5615f5a&"
import script from "./secondLogoRow.vue?vue&type=script&lang=js&"
export * from "./secondLogoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports